class RosfoProductQa extends HTMLElement {
  connectedCallback() {
    this.fullDialog = this.querySelector('[data-qa-dialog]');
    this.answerDialog = this.querySelector('[data-qa-answer-dialog]');
    this.answerQuestion = this.querySelector('[data-qa-answer-question]');
    this.answerQuestionInput = this.querySelector('[data-qa-answer-question-input]');

    this.addEventListener('click', this.handleClick);
    this.addEventListener('submit', this.handleSubmit);

    this.setupAnswerClamps();

    const answerResult = this.querySelector(
      '[data-qa-answer-success], [data-qa-answer-errors]'
    );

    if (answerResult && this.answerDialog && !this.answerDialog.open) {
      this.answerDialog.showModal();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('submit', this.handleSubmit);
  }

  setupAnswerClamps() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const answerTexts = this.querySelectorAll(
      '.rosfo-qa__answer-text'
    );

    answerTexts.forEach((answerText) => {
      if (answerText.dataset.qaClampReady === 'true') return;

      answerText.dataset.qaClampReady = 'true';
      answerText.dataset.qaCollapsed = 'true';

      /*
       * Hidden View More dialog content has no measurable height.
       * Leave those answers fully expanded.
       */
      if (answerText.clientHeight === 0) {
        delete answerText.dataset.qaCollapsed;
        return;
      }

      /*
       * With the one-line clamp active:
       * scrollHeight > clientHeight means the answer really overflows.
       */
      if (answerText.scrollHeight <= answerText.clientHeight + 1) {
        delete answerText.dataset.qaCollapsed;
        return;
      }

      const toggle = document.createElement('button');

      toggle.type = 'button';
      toggle.className = 'rosfo-qa__answer-toggle';
      toggle.dataset.qaAnswerToggle = '';
      toggle.textContent = 'More';
      toggle.setAttribute('aria-expanded', 'false');

      answerText.insertAdjacentElement('afterend', toggle);
    });
  }

  handleClick = (event) => {
    const answerToggle = event.target.closest(
      '[data-qa-answer-toggle]'
    );

    if (answerToggle && this.contains(answerToggle)) {
      const answerText = answerToggle.previousElementSibling;

      if (
        answerText &&
        answerText.classList.contains('rosfo-qa__answer-text')
      ) {
        const isCollapsed =
          answerText.dataset.qaCollapsed === 'true';

        answerText.dataset.qaCollapsed =
          isCollapsed ? 'false' : 'true';

        answerToggle.textContent =
          isCollapsed ? 'Less' : 'More';

        answerToggle.setAttribute(
          'aria-expanded',
          isCollapsed ? 'true' : 'false'
        );
      }

      return;
    }

    const askButton = event.target.closest('[data-qa-ask]');

    if (askButton && this.contains(askButton)) {
      this.openQuestionDialog();
      return;
    }

    const answerButton = event.target.closest('[data-qa-answer]');

    if (answerButton && this.contains(answerButton)) {
      const question = answerButton.dataset.question || '';

      if (this.answerQuestion) {
        this.answerQuestion.textContent = question;
      }

      if (this.answerQuestionInput) {
        this.answerQuestionInput.value = question;
      }

      if (this.answerDialog && !this.answerDialog.open) {
        this.answerDialog.showModal();
      }

      return;
    }

    const viewMoreButton = event.target.closest('[data-qa-view-more]');

    if (viewMoreButton && this.contains(viewMoreButton)) {
      if (this.fullDialog && !this.fullDialog.open) {
        this.fullDialog.showModal();
      }

      return;
    }

    const fullDialogClose = event.target.closest('[data-qa-dialog-close]');

    if (fullDialogClose && this.contains(fullDialogClose)) {
      this.fullDialog?.close();
      return;
    }

    const answerDialogClose = event.target.closest(
      '[data-qa-answer-dialog-close]'
    );

    if (answerDialogClose && this.contains(answerDialogClose)) {
      this.answerDialog?.close();
      return;
    }

    if (event.target === this.fullDialog) {
      this.fullDialog.close();
      return;
    }

    if (event.target === this.answerDialog) {
      this.answerDialog.close();
    }
  };

  handleSubmit = (event) => {
    const form = event.target.closest('[data-qa-answer-form]');

    if (!form || !this.contains(form)) return;

    const submitButton = form.querySelector('[data-qa-answer-submit]');

    if (!submitButton) return;

    submitButton.disabled = true;
    submitButton.textContent = 'Submitting…';
  };

  openQuestionDialog() {
    const productActions = Array.from(
      document.querySelectorAll('rosfo-product-question')
    ).find(
      (element) =>
        String(element.dataset.productId) === String(this.dataset.productId)
    );

    const questionDialog = productActions?.querySelector(
      '[data-question-dialog]'
    );

    if (questionDialog && !questionDialog.open) {
      questionDialog.showModal();
    }
  }
}

if (!customElements.get('rosfo-product-qa')) {
  customElements.define('rosfo-product-qa', RosfoProductQa);
}
